import * as React from "react";
import { useState, useEffect } from "react";
import { Field, withTypes, FormSpy } from "react-final-form";
import axios from "axios";

import {
    Button,
    CircularProgress,
    TextField,
    Switch,
    FormControlLabel,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    InputAdornment,
    Select,
    MenuItem,
    FormControl,
} from "@material-ui/core";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import ShareIcon from "@material-ui/icons/Share";
import ViewCarouselIcon from "@material-ui/icons/ViewCarousel";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import EventIcon from "@material-ui/icons/Event";

import { Notification, useNotify } from "react-admin";
import { API } from "../Constant";
import { getConfigGet, getConfigPost, getConfigPatch } from "../getConfig";

const useStyles = makeStyles((theme) => ({
    main: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        padding: theme.spacing(3),
        backgroundColor: "#f5f5f5",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 600,
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    accordion: {
        marginBottom: theme.spacing(1),
        "&:before": {
            display: "none",
        },
        overflow: "hidden",
    },
    accordionSummary: {
        backgroundColor: "#fafafa",
        borderBottom: "1px solid #e0e0e0",
    },
    sectionIcon: {
        marginRight: theme.spacing(1),
        color: theme.palette.primary.main,
    },
    sectionTitle: {
        fontWeight: 500,
    },
    sectionDescription: {
        color: theme.palette.text.secondary,
        fontSize: "0.875rem",
        marginLeft: theme.spacing(1),
    },
    fieldGrid: {
        display: "grid !important",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "32px 24px !important",
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: "repeat(2, 1fr)",
        },
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: "1fr",
        },
    },
    textAreaGrid: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: theme.spacing(3),
        marginTop: theme.spacing(2),
    },
    shareFieldGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "24px 20px",
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: "1fr",
        },
    },
    accordionDetails: {
        display: "block",
        overflow: "hidden",
        padding: theme.spacing(3),
        paddingRight: theme.spacing(4),
    },
    input: {
        marginBottom: theme.spacing(1),
    },
    actions: {
        padding: theme.spacing(2),
        display: "flex",
        gap: theme.spacing(2),
        justifyContent: "flex-end",
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
    },
    statusSwitch: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(2),
    },
    previewContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        width: "100%",
        alignItems: "flex-start",
        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
        },
    },
    previewFields: {
        flex: "1 1 auto",
        minWidth: 0,
        paddingRight: theme.spacing(6),
    },
    phonePreview: {
        flex: "0 0 300px",
        width: 300,
        marginLeft: theme.spacing(4),
        backgroundColor: "#fff",
        borderRadius: 24,
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        overflow: "hidden",
        border: "8px solid #1a1a2e",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    phoneHeader: {
        height: 60,
        background: "linear-gradient(90deg, #2d5016 0%, #1e3a5f 25%, #4a1942 50%, #1e3a5f 75%, #666 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative" as const,
    },
    phoneContent: {
        padding: theme.spacing(2),
        textAlign: "center" as const,
        backgroundColor: "#fff",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    phoneIcon: {
        width: 50,
        height: 50,
        borderRadius: "50%",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "-25px auto 16px",
        border: "3px solid #1a1a2e",
        position: "relative" as const,
    },
    phoneIconBadge: {
        position: "absolute" as const,
        bottom: -2,
        right: -2,
        width: 20,
        height: 20,
        borderRadius: "50%",
        backgroundColor: "#f5a623",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14,
        fontWeight: "bold" as const,
        color: "#1a1a2e",
    },
    phoneTitle: {
        fontSize: 18,
        fontWeight: 700,
        color: "#1a1a2e",
        marginBottom: 8,
        lineHeight: 1.3,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    phoneSubtitle: {
        fontSize: 13,
        color: "#666",
        marginBottom: 16,
        lineHeight: 1.4,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    phoneCodeSection: {
        backgroundColor: "#f8f8f8",
        borderRadius: 12,
        padding: theme.spacing(1.5),
        marginBottom: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    phoneCodeLabel: {
        fontSize: 11,
        color: "#999",
        textAlign: "left" as const,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    phoneCode: {
        fontSize: 16,
        fontWeight: 700,
        color: "#1a1a2e",
        letterSpacing: 2,
        textAlign: "left" as const,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    phoneCopyButton: {
        border: "1px solid #d63384",
        borderRadius: 20,
        padding: "6px 12px",
        fontSize: 12,
        color: "#d63384",
        backgroundColor: "transparent",
        display: "flex",
        alignItems: "center",
        gap: 4,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    phoneCTA: {
        backgroundColor: "#d63384",
        color: "#fff",
        borderRadius: 30,
        padding: "14px 24px",
        fontSize: 14,
        fontWeight: 600,
        border: "none",
        width: "100%",
        cursor: "pointer",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    // Boost Screen Preview Styles
    boostPreviewContainer: {
        display: "flex",
        flexDirection: "row",
        gap: theme.spacing(4),
        width: "100%",
        alignItems: "flex-start",
    },
    boostFormSection: {
        flex: "1 1 auto",
        minWidth: 0,
    },
    boostVariationSelect: {
        marginBottom: theme.spacing(3),
        minWidth: 300,
    },
    boostPreview: {
        flex: "0 0 320px",
        width: 320,
        backgroundColor: "#f5f5f5",
        borderRadius: 24,
        marginLeft: 12,
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        overflow: "hidden",
        border: "8px solid #1a1a2e",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    boostPreviewHeader: {
        backgroundColor: "#fff",
        padding: theme.spacing(3),
        textAlign: "center" as const,
        position: "relative" as const,
    },
    boostFireIcon: {
        width: 80,
        height: 80,
        marginBottom: theme.spacing(1),
    },
    boostBadge: {
        position: "absolute" as const,
        top: 70,
        left: "50%",
        transform: "translateX(20px)",
        width: 32,
        height: 32,
        borderRadius: "50%",
        backgroundColor: "#1a1a2e",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14,
        fontWeight: 700,
    },
    boostPreviewTitle: {
        fontSize: 22,
        fontWeight: 700,
        color: "#1a1a2e",
        marginTop: theme.spacing(1),
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    boostPreviewSubtitle: {
        fontSize: 14,
        color: "#666",
        marginTop: theme.spacing(1),
        lineHeight: 1.4,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    boostBrandCards: {
        display: "flex",
        justifyContent: "space-around",
        gap: theme.spacing(1),
        paddingHorizontal: theme.spacing(0.5),
        paddingVertical: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: "#fff",
    },
    boostBrandCard: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
        position: "relative" as const,
    },
    boostBrandCardInner: {
        width: 95,
        height: 95,
        backgroundColor: "#fff",
        borderRadius: 14,
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        display: "flex",
        flexDirection: "column" as const,
        position: "relative" as const,
    },
    boostBrandLogoSection: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        padding: "8px",
        width: 72,
        height: 72,
        objectFit: "contain" as const,
        alignSelf: "center",
    },
    boostBrandLogo: {
        width: "100%",
        height: "auto",
        maxHeight: 50,
        objectFit: "contain" as const,
    },
    boostDiscountBar: {
        background: "linear-gradient(90deg, #DE6C00 24.76%, #FFAE00 43.69%)",
        padding: "4px 12px 4px 40px",
        display: "flex",
        alignItems: "center",
    },
    boostDiscountText: {
        fontSize: 16,
        fontWeight: 600,
        color: "#051A3F",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    boostFireContainer: {
        position: "absolute" as const,
        bottom: 2,
        left: -4,
        zIndex: 2,
        width: 45,
        height: 45,
    },
    boostBadgeFireIcon: {
        width: 45,
        height: 45,
        display: "block",
    },
    boostFlashIcon: {
        position: "absolute" as const,
        bottom: 4,
        left: "50%",
        transform: "translateX(-50%)",
        width: 12,
        height: 15,
    },
    boostCtaSection: {
        backgroundColor: "#f5f5f5",
        padding: theme.spacing(3),
        paddingTop: theme.spacing(2),
        textAlign: "center" as const,
        borderTop: "1px solid #e0e0e0",
    },
    boostCtaIcon: {
        width: 60,
        height: 52,
        marginBottom: theme.spacing(1.5),
    },
    boostCtaTitle: {
        fontSize: 17,
        fontWeight: 700,
        color: "#1a1a2e",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
        lineHeight: 1.3,
    },
    boostCtaSubtitle: {
        fontSize: 13,
        color: "#555",
        marginTop: 8,
        marginBottom: theme.spacing(2.5),
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
        lineHeight: 1.4,
        padding: "0 8px",
    },
    boostButtonsRow: {
        display: "flex",
        gap: theme.spacing(1.5),
        justifyContent: "space-around",
    },
    boostButtonPrimary: {
        border: "2px solid #c91e5a",
        borderRadius: 30,
        padding: "12px",
        fontSize: 14,
        fontWeight: 600,
        color: "#c91e5a",
        backgroundColor: "#fff",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
        minWidth: 100,
    },
    boostButtonSecondary: {
        background: "linear-gradient(135deg, #c91e5a 0%, #e84c8a 100%)",
        color: "#fff",
        borderRadius: 30,
        padding: "12px",
        fontSize: 14,
        fontWeight: 600,
        border: "none",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
        minWidth: 100,
    },
    // Rewards Screen Preview Styles
    rewardsPreviewContainer: {
        display: "flex",
        flexDirection: "row" as const,
        gap: theme.spacing(4),
        width: "100%",
        alignItems: "flex-start",
    },
    rewardsFormSection: {
        flex: "1 1 auto",
        minWidth: 0,
    },
    rewardsPreview: {
        flex: "0 0 320px",
        width: 320,
        background: "#FFAE00",
        borderRadius: 24,
        marginLeft: 12,
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        overflow: "hidden",
        border: "8px solid #1a1a2e",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
        display: "flex",
        flexDirection: "column" as const,
    },
    rewardsStatsRow: {
        display: "flex",
        justifyContent: "space-between",
        padding: "16px 16px 8px",
    },
    rewardsStatBox: {
        display: "flex",
        flexDirection: "column" as const,
    },
    rewardsStatLabel: {
        fontSize: 12,
        color: "#1a1a2e",
        marginBottom: 4,
        fontWeight: 500,
    },
    rewardsStatValue: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        backgroundColor: "rgba(255,255,255,0.3)",
        borderRadius: 20,
        padding: "6px 12px",
    },
    rewardsEarnedBadge: {
        backgroundColor: "#fff",
        borderRadius: 20,
        padding: "6px 16px",
        border: "2px solid #1a1a2e",
    },
    rewardsPastReferrals: {
        fontSize: 11,
        color: "#1a1a2e",
        marginTop: 4,
    },
    rewardsMainContent: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
        padding: "16px",
        textAlign: "center" as const,
    },
    rewardsFireIcon: {
        width: 50,
        height: 50,
        marginBottom: 8,
        position: "relative" as const,
    },
    rewardsBadgeText: {
        fontSize: 13,
        color: "#1a1a2e",
        marginBottom: 8,
        fontWeight: 500,
    },
    rewardsTitle: {
        fontSize: 24,
        fontWeight: 700,
        color: "#1a1a2e",
        lineHeight: 1.2,
        marginBottom: 16,
        paddingRight: 40,
        paddingLeft: 40,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    rewardsCoinsSection: {
        flex: 1,
        backgroundImage: "url('/pounds.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: 255,
        width: 336,
        position: "relative" as const,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    rewardsCoinStack: {
        position: "relative" as const,
        width: 100,
        height: 120,
    },
    rewardsCoin: {
        position: "absolute" as const,
        left: "50%",
        transform: "translateX(-50%)",
        width: 90,
        height: "auto",
        animation: "$coinFall 0.5s ease-out forwards",
        opacity: 0,
    },
    "@keyframes coinFall": {
        "0%": {
            opacity: 0,
            transform: "translateX(-50%) translateY(-100px)",
        },
        "100%": {
            opacity: 1,
            transform: "translateX(-50%) translateY(0)",
        },
    },
    rewardsBottomSection: {
        padding: "16px",
        backgroundColor: "#FFAE00",
    },
    rewardsCtaButton: {
        backgroundColor: "#1a1a2e",
        color: "#fff",
        borderRadius: 30,
        padding: "14px 24px",
        fontSize: 16,
        fontWeight: 600,
        width: 243,
        textAlign: "center" as const,
        marginBottom: 12,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    rewardsFooterText: {
        fontSize: 12,
        color: "#1a1a2e",
        textAlign: "center" as const,
    },
}));

// Boost Screen Variation interface
interface BoostScreenVariation {
    title?: string;
    subtitle?: string;
    cta_title?: string;
    cta_subtitle?: string;
    primary_button_text?: string;
    primary_button_action?: string;
    secondary_button_text?: string;
    secondary_button_action?: string;
    highlight_text?: string;
}

interface BoostScreenConfig {
    non_sprive_plus_no_boost?: BoostScreenVariation;
    sprive_plus_no_boost?: BoostScreenVariation;
    sprive_plus_active_boost?: BoostScreenVariation;
    ambassador_no_boost?: BoostScreenVariation;
    ambassador_active_boost?: BoostScreenVariation;
}

// Variation options for dropdown
const BOOST_VARIATIONS = [
    { key: 'non_sprive_plus_no_boost', label: 'Non-Sprive Plus - No Boost', userType: 'New User', boostStatus: 'No Boost' },
    { key: 'sprive_plus_no_boost', label: 'Sprive Plus - No Boost', userType: 'Sprive Plus', boostStatus: 'No Boost' },
    { key: 'sprive_plus_active_boost', label: 'Sprive Plus - Active Boost', userType: 'Sprive Plus', boostStatus: 'Active' },
    { key: 'ambassador_no_boost', label: 'Ambassador - No Boost', userType: 'Ambassador', boostStatus: 'No Boost' },
    { key: 'ambassador_active_boost', label: 'Ambassador - Active Boost', userType: 'Ambassador', boostStatus: 'Active' },
];

// Featured brand interface
interface FeaturedBrand {
    id: number;
    brandName: string;
    brandLogo: string;
    discount: number;
}

// Rewards screen variation interface
interface RewardsScreenVariation {
    badge_text?: string;
    title?: string;
    cta_text?: string;
    footer_text?: string;
}

interface RewardsScreenConfig {
    normal_user?: RewardsScreenVariation;
    ambassador?: RewardsScreenVariation;
}

interface ReferralConfigFormValues {
    id?: number;
    // Campaign Settings
    name?: string;
    start_date?: string;
    end_date?: string;
    priority?: string;
    is_boost_enabled?: boolean;
    // Regular Referrer Rewards
    referrer_gets_sprive_plus?: boolean;
    referrer_gets_boost?: boolean;
    referrer_bonus_amount?: string;
    // Ambassador Rewards
    ambassador_threshold?: string;
    ambassador_gets_sprive_plus?: boolean;
    ambassador_gets_boost?: boolean;
    ambassador_bonus_amount?: string;
    // Referred User Rewards
    referred_gets_sprive_plus?: boolean;
    referred_gets_boost?: boolean;
    referred_bonus_amount?: string;
    // Budget Settings
    weekly_referral_budget?: string;
    // Boost Settings
    boost_duration_days?: string;
    boost_weeks_per_referral?: string;
    max_boost_weeks?: string;
    boost_haircut_percentage?: string;
    // Share Screen Config
    share_screen_title?: string;
    share_screen_subtitle?: string;
    share_screen_cta_text?: string;
    share_message_template?: string;
    // Featured Brands
    featured_brand_id_1?: string;
    featured_brand_id_2?: string;
    featured_brand_id_3?: string;
    // Boost Screen Config (JSON - 5 variations)
    boost_screen_config?: BoostScreenConfig;
    // Rewards Screen Config (JSON - 2 variations)
    rewards_screen_config?: RewardsScreenConfig;
    // Status
    is_active?: boolean;
}

interface CampaignListItem {
    id: number;
    name: string;
    start_date: string | null;
    end_date: string | null;
    priority: number;
    is_active: boolean;
}

const renderInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            size="small"
        />
    </div>
);

const renderNumberInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            size="small"
            type="number"
        />
    </div>
);

const renderCurrencyInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            size="small"
            type="number"
            InputProps={{
                startAdornment: <InputAdornment position="start">£</InputAdornment>,
            }}
        />
    </div>
);

const renderTextArea = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            multiline
            rows={3}
        />
    </div>
);

const renderLargeTextArea = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            multiline
            rows={6}
        />
    </div>
);

const renderSwitch = ({ input, label }: any) => {
    // For checkbox type fields, react-final-form uses input.checked
    // For regular fields, use input.value
    const isChecked = input.checked !== undefined ? input.checked : !!input.value;
    return (
        <FormControlLabel
            control={
                <Switch
                    checked={isChecked}
                    onChange={(event) => {
                        input.onChange(event.target.checked);
                    }}
                    color="primary"
                />
            }
            label={label}
        />
    );
};

const { Form } = withTypes<ReferralConfigFormValues>();

const REFERRAL_CONFIG_ENDPOINT = API + "/referral-v2-config";

const GIFT_BRANDS_ENDPOINT = API + "/admin/gift-card-brand-details";

const ReferralConfig = () => {
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [configId, setConfigId] = useState<number | null>(null);
    const [initialValues, setInitialValues] = useState<ReferralConfigFormValues>({});
    const [expandedSections, setExpandedSections] = useState<string[]>(["campaign"]);
    const [selectedVariation, setSelectedVariation] = useState<string>('non_sprive_plus_no_boost');
    const [boostScreenConfig, setBoostScreenConfig] = useState<BoostScreenConfig>({});
    const [rewardsScreenConfig, setRewardsScreenConfig] = useState<RewardsScreenConfig>({});
    const [selectedRewardsVariation, setSelectedRewardsVariation] = useState<string>('normal_user');
    const [featuredBrands, setFeaturedBrands] = useState<FeaturedBrand[]>([]);
    const [brandIds, setBrandIds] = useState<{id1?: number, id2?: number, id3?: number}>({});
    // Campaign management
    const [campaigns, setCampaigns] = useState<CampaignListItem[]>([]);
    const [selectedCampaignId, setSelectedCampaignId] = useState<number | null>(null);
    const [isCreatingNew, setIsCreatingNew] = useState(false);
    const notify = useNotify();
    const classes = useStyles();

    useEffect(() => {
        fetchConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch brand details when brand IDs change
    useEffect(() => {
        const fetchBrandDetails = async () => {
            const ids = [brandIds.id1, brandIds.id2, brandIds.id3].filter(id => id);
            if (ids.length === 0) {
                setFeaturedBrands([]);
                return;
            }

            try {
                const config = getConfigGet({});
                const brands: FeaturedBrand[] = [];

                for (const id of ids) {
                    if (id) {
                        try {
                            const response: any = await axios.get(`${GIFT_BRANDS_ENDPOINT}/${id}`, config);
                            if (response.data) {
                                const brand = response.data;
                                brands.push({
                                    id: brand.id,
                                    brandName: brand.brand_name || 'Unknown',
                                    brandLogo: brand.logo_url || '',
                                    discount: parseFloat(brand.discount) || 0
                                });
                            }
                        } catch (err) {
                            console.warn(`Failed to fetch brand ${id}:`, err);
                        }
                    }
                }
                setFeaturedBrands(brands);
            } catch (error) {
                console.error("Failed to fetch brand details:", error);
            }
        };

        fetchBrandDetails();
    }, [brandIds]);

    const fetchConfig = async () => {
        try {
            setInitialLoading(true);
            const config = getConfigGet({});
            const response: any = await axios.get(REFERRAL_CONFIG_ENDPOINT, config);

            // API returns: { total, limit, skip, data: [...] }
            if (response.data?.data?.length > 0) {
                const allCampaigns = response.data.data;

                // Build campaign list for dropdown
                const campaignList: CampaignListItem[] = allCampaigns.map((c: any) => ({
                    id: c.id,
                    name: c.name || 'Default',
                    start_date: c.start_date,
                    end_date: c.end_date,
                    priority: c.priority || 0,
                    is_active: c.is_active
                }));
                setCampaigns(campaignList);

                // Find and load the "Default" campaign, or first one if no Default
                const defaultCampaign = allCampaigns.find((c: any) => c.name === 'Default' || !c.name) || allCampaigns[0];
                loadCampaignData(defaultCampaign);
                setSelectedCampaignId(defaultCampaign.id);
            }
        } catch (error) {
            console.error("Failed to fetch config:", error);
            notify("Failed to load referral configuration", "warning");
        } finally {
            setInitialLoading(false);
        }
    };

    const loadCampaignData = (configData: any) => {
        setConfigId(configData.id);
        setInitialValues({
            ...configData,
            // Ensure dates are formatted for input fields
            start_date: configData.start_date ? configData.start_date.split('T')[0] : '',
            end_date: configData.end_date ? configData.end_date.split('T')[0] : '',
            // Ensure booleans are proper booleans (MySQL returns 1/0)
            is_boost_enabled: configData.is_boost_enabled === true || configData.is_boost_enabled === 1,
            is_active: configData.is_active === true || configData.is_active === 1,
            // Regular Referrer Rewards
            referrer_gets_sprive_plus: configData.referrer_gets_sprive_plus === true || configData.referrer_gets_sprive_plus === 1,
            referrer_gets_boost: configData.referrer_gets_boost === true || configData.referrer_gets_boost === 1,
            // Ambassador Rewards
            ambassador_gets_sprive_plus: configData.ambassador_gets_sprive_plus === true || configData.ambassador_gets_sprive_plus === 1,
            ambassador_gets_boost: configData.ambassador_gets_boost === true || configData.ambassador_gets_boost === 1,
            // Referred User Rewards
            referred_gets_sprive_plus: configData.referred_gets_sprive_plus === true || configData.referred_gets_sprive_plus === 1,
            referred_gets_boost: configData.referred_gets_boost === true || configData.referred_gets_boost === 1,
        });
        // Set boost screen config from JSON field
        if (configData.boost_screen_config) {
            setBoostScreenConfig(configData.boost_screen_config);
        } else {
            setBoostScreenConfig({});
        }
        // Set rewards screen config from JSON field
        if (configData.rewards_screen_config) {
            setRewardsScreenConfig(configData.rewards_screen_config);
        } else {
            setRewardsScreenConfig({});
        }
        // Set brand IDs to trigger brand fetch
        setBrandIds({
            id1: configData.featured_brand_id_1,
            id2: configData.featured_brand_id_2,
            id3: configData.featured_brand_id_3
        });
        setIsCreatingNew(false);
    };

    const handleCampaignChange = async (campaignId: number | 'new') => {
        if (campaignId === 'new') {
            // Create new campaign based on Default
            const defaultCampaign = campaigns.find(c => c.name === 'Default');
            if (defaultCampaign) {
                // Fetch full default campaign data
                const config = getConfigGet({});
                const response: any = await axios.get(`${REFERRAL_CONFIG_ENDPOINT}/${defaultCampaign.id}`, config);
                if (response.data) {
                    const newCampaignData = {
                        ...response.data,
                        id: undefined,
                        name: '',
                        start_date: '',
                        end_date: '',
                        priority: 10, // Higher than default
                        // Ensure booleans are proper booleans (MySQL returns 1/0)
                        is_boost_enabled: response.data.is_boost_enabled === true || response.data.is_boost_enabled === 1,
                        is_active: response.data.is_active === true || response.data.is_active === 1,
                        // Regular Referrer Rewards
                        referrer_gets_sprive_plus: response.data.referrer_gets_sprive_plus === true || response.data.referrer_gets_sprive_plus === 1,
                        referrer_gets_boost: response.data.referrer_gets_boost === true || response.data.referrer_gets_boost === 1,
                        // Ambassador Rewards
                        ambassador_gets_sprive_plus: response.data.ambassador_gets_sprive_plus === true || response.data.ambassador_gets_sprive_plus === 1,
                        ambassador_gets_boost: response.data.ambassador_gets_boost === true || response.data.ambassador_gets_boost === 1,
                        // Referred User Rewards
                        referred_gets_sprive_plus: response.data.referred_gets_sprive_plus === true || response.data.referred_gets_sprive_plus === 1,
                        referred_gets_boost: response.data.referred_gets_boost === true || response.data.referred_gets_boost === 1,
                    };
                    setConfigId(null);
                    setInitialValues(newCampaignData);
                    if (response.data.boost_screen_config) {
                        setBoostScreenConfig(response.data.boost_screen_config);
                    }
                    if (response.data.rewards_screen_config) {
                        setRewardsScreenConfig(response.data.rewards_screen_config);
                    }
                    setBrandIds({
                        id1: response.data.featured_brand_id_1,
                        id2: response.data.featured_brand_id_2,
                        id3: response.data.featured_brand_id_3
                    });
                }
            } else {
                // No default, start fresh
                setConfigId(null);
                setInitialValues({
                    name: '',
                    priority: '10',
                    is_boost_enabled: true,
                    is_active: true,
                    // Default referrer rewards
                    referrer_gets_sprive_plus: false,
                    referrer_gets_boost: true,
                    referrer_bonus_amount: '5.00',
                    // Default ambassador rewards
                    ambassador_threshold: '10',
                    ambassador_gets_sprive_plus: false,
                    ambassador_gets_boost: true,
                    ambassador_bonus_amount: '10.00',
                    // Default referred user rewards
                    referred_gets_sprive_plus: true,
                    referred_gets_boost: false,
                    referred_bonus_amount: '0.00',
                });
                setBoostScreenConfig({});
                setRewardsScreenConfig({});
                setBrandIds({});
            }
            setSelectedCampaignId(null);
            setIsCreatingNew(true);
        } else {
            // Load existing campaign
            const config = getConfigGet({});
            const response: any = await axios.get(`${REFERRAL_CONFIG_ENDPOINT}/${campaignId}`, config);
            if (response.data) {
                loadCampaignData(response.data);
                setSelectedCampaignId(campaignId);
            }
        }
    };

    const handleSubmit = async (data: ReferralConfigFormValues) => {
        setLoading(true);

        // Validate campaign name for new campaigns
        if (isCreatingNew && !data.name?.trim()) {
            notify("Please enter a campaign name", "warning");
            setLoading(false);
            return;
        }

        // Convert string numbers to actual numbers for numeric fields
        const payload = {
            // Campaign settings
            name: data.name || 'Default',
            start_date: data.start_date || null,
            end_date: data.end_date || null,
            priority: parseInt(data.priority || "0"),
            is_boost_enabled: data.is_boost_enabled ?? true,
            // Regular Referrer Rewards
            referrer_gets_sprive_plus: data.referrer_gets_sprive_plus ?? false,
            referrer_gets_boost: data.referrer_gets_boost ?? true,
            referrer_bonus_amount: parseFloat(data.referrer_bonus_amount || "5"),
            // Ambassador Rewards
            ambassador_threshold: parseInt(data.ambassador_threshold || "10"),
            ambassador_gets_sprive_plus: data.ambassador_gets_sprive_plus ?? false,
            ambassador_gets_boost: data.ambassador_gets_boost ?? true,
            ambassador_bonus_amount: parseFloat(data.ambassador_bonus_amount || "10"),
            // Referred User Rewards
            referred_gets_sprive_plus: data.referred_gets_sprive_plus ?? true,
            referred_gets_boost: data.referred_gets_boost ?? false,
            referred_bonus_amount: parseFloat(data.referred_bonus_amount || "0"),
            // Budget & Boost settings
            weekly_referral_budget: parseFloat(data.weekly_referral_budget || "2500"),
            boost_duration_days: parseInt(data.boost_duration_days || "7"),
            boost_weeks_per_referral: parseInt(data.boost_weeks_per_referral || "1"),
            max_boost_weeks: parseInt(data.max_boost_weeks || "10"),
            boost_haircut_percentage: parseFloat(data.boost_haircut_percentage || "0"),
            share_screen_title: data.share_screen_title,
            share_screen_subtitle: data.share_screen_subtitle,
            share_screen_cta_text: data.share_screen_cta_text,
            share_message_template: data.share_message_template,
            featured_brand_id_1: data.featured_brand_id_1 ? parseInt(data.featured_brand_id_1) : null,
            featured_brand_id_2: data.featured_brand_id_2 ? parseInt(data.featured_brand_id_2) : null,
            featured_brand_id_3: data.featured_brand_id_3 ? parseInt(data.featured_brand_id_3) : null,
            // Boost Screen Config (JSON with 5 variations)
            boost_screen_config: boostScreenConfig,
            // Rewards Screen Config (JSON with 2 variations)
            rewards_screen_config: rewardsScreenConfig,
            is_active: data.is_active ?? true,
        };

        // Update brand IDs to refresh preview
        setBrandIds({
            id1: data.featured_brand_id_1 ? parseInt(data.featured_brand_id_1) : undefined,
            id2: data.featured_brand_id_2 ? parseInt(data.featured_brand_id_2) : undefined,
            id3: data.featured_brand_id_3 ? parseInt(data.featured_brand_id_3) : undefined
        });

        try {
            if (configId) {
                // Update existing config
                const headers = getConfigPatch();
                await axios.patch(`${REFERRAL_CONFIG_ENDPOINT}/${configId}`, payload, { headers });
                notify(`Campaign "${payload.name}" updated successfully`, "info");
                // Refresh campaign list
                fetchConfig();
            } else {
                // Create new config
                const headers = getConfigPost();
                const response: any = await axios.post(REFERRAL_CONFIG_ENDPOINT, payload, { headers });
                if (response.data?.status && response.data?.data?.id) {
                    setConfigId(response.data.data.id);
                    setSelectedCampaignId(response.data.data.id);
                }
                notify(`Campaign "${payload.name}" created successfully`, "info");
                setIsCreatingNew(false);
                // Refresh campaign list
                fetchConfig();
            }
        } catch (error) {
            notify(
                (error as any)?.response?.data?.message || "Failed to save referral configuration",
                "error",
                "",
                undefined,
                50000
            );
        } finally {
            setLoading(false);
        }
    };

    const handleAccordionChange = (panel: string) => (_event: any, isExpanded: boolean) => {
        setExpandedSections(
            isExpanded
                ? [...expandedSections, panel]
                : expandedSections.filter((s) => s !== panel)
        );
    };

    // Update a specific field in the selected boost variation
    const updateBoostVariationField = (field: keyof BoostScreenVariation, value: string) => {
        setBoostScreenConfig(prev => ({
            ...prev,
            [selectedVariation]: {
                ...(prev[selectedVariation as keyof BoostScreenConfig] || {}),
                [field]: value
            }
        }));
    };

    // Update a specific field in the selected rewards variation
    const updateRewardsVariationField = (field: keyof RewardsScreenVariation, value: string) => {
        setRewardsScreenConfig(prev => ({
            ...prev,
            [selectedRewardsVariation]: {
                ...(prev[selectedRewardsVariation as keyof RewardsScreenConfig] || {}),
                [field]: value
            }
        }));
    };

    // Get current variation data
    const currentVariation = boostScreenConfig[selectedVariation as keyof BoostScreenConfig] || {};
    const currentRewardsVariation = rewardsScreenConfig[selectedRewardsVariation as keyof RewardsScreenConfig] || {};

    if (initialLoading) {
        return (
            <div className={classes.loadingContainer}>
                <CircularProgress size={40} />
            </div>
        );
    }

    return (
        <Form
            key={`campaign-${selectedCampaignId || 'new'}-${isCreatingNew}`}
            onSubmit={handleSubmit}
            initialValues={initialValues}
            render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} noValidate>
                    <div className={classes.main}>
                        <div className={classes.header}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
                                <Typography variant="h5" className={classes.title}>
                                    Referral Configuration
                                </Typography>
                                {/* Campaign Selector */}
                                <FormControl variant="outlined" size="small" style={{ minWidth: 250 }}>
                                    <Select
                                        value={isCreatingNew ? 'new' : (selectedCampaignId || '')}
                                        onChange={(e) => handleCampaignChange(e.target.value as number | 'new')}
                                        displayEmpty
                                    >
                                        {campaigns.map((campaign) => (
                                            <MenuItem key={campaign.id} value={campaign.id}>
                                                {campaign.name}
                                                {campaign.start_date && (
                                                    <span style={{ marginLeft: 8, fontSize: 11, color: '#666' }}>
                                                        ({new Date(campaign.start_date).toLocaleDateString()} - {campaign.end_date ? new Date(campaign.end_date).toLocaleDateString() : '∞'})
                                                    </span>
                                                )}
                                                {!campaign.is_active && <span style={{ marginLeft: 8, color: '#999' }}>(Inactive)</span>}
                                            </MenuItem>
                                        ))}
                                        <MenuItem value="new" style={{ borderTop: '1px solid #e0e0e0', fontWeight: 600, color: '#1976d2' }}>
                                            + Create New Campaign
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                disabled={loading}
                            >
                                {loading && <CircularProgress size={20} thickness={2} style={{ marginRight: 8 }} />}
                                {isCreatingNew ? "Create Campaign" : "Update Campaign"}
                            </Button>
                        </div>

                        {/* Section 0: Campaign Settings */}
                        <Accordion
                            className={classes.accordion}
                            expanded={expandedSections.includes("campaign")}
                            onChange={handleAccordionChange("campaign")}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <EventIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Campaign Settings</Typography>
                                <Typography className={classes.sectionDescription}>
                                    {isCreatingNew ? "Configure your new campaign" : `Editing: ${initialValues.name || 'Default'}`}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <Field
                                        name="name"
                                        component={renderInput}
                                        label="Campaign Name"
                                        placeholder="e.g., Flash Week, Dragons Den"
                                        disabled={initialValues.name === 'Default' && !isCreatingNew}
                                    />
                                    <Field
                                        name="start_date"
                                        component={renderInput}
                                        label="Start Date (leave empty for always active)"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <Field
                                        name="end_date"
                                        component={renderInput}
                                        label="End Date (leave empty for no end)"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <Field
                                        name="priority"
                                        component={renderNumberInput}
                                        label="Priority (higher = takes precedence)"
                                        placeholder="0"
                                    />
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Field
                                            name="is_boost_enabled"
                                            component={renderSwitch}
                                            label="Boost Enabled for this Campaign"
                                            type="checkbox"
                                        />
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* Section 1: Budget Settings */}
                        <Accordion
                            className={classes.accordion}
                            expanded={expandedSections.includes("budget")}
                            onChange={handleAccordionChange("budget")}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <AccountBalanceWalletIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Budget Settings</Typography>
                                <Typography className={classes.sectionDescription}>
                                    Set weekly budget caps for referral payouts
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <Field
                                        name="weekly_referral_budget"
                                        component={renderCurrencyInput}
                                        label="Weekly Referral Budget"
                                        placeholder="2500.00"
                                    />
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* Section 2: Commission Settings - NEW CONFIGURABLE REWARDS */}
                        <Accordion
                            className={classes.accordion}
                            expanded={expandedSections.includes("commission")}
                            onChange={handleAccordionChange("commission")}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <MonetizationOnIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Reward Settings</Typography>
                                <Typography className={classes.sectionDescription}>
                                    Configure what referrers and referred users receive
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                {/* Regular Referrer Rewards */}
                                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 16, color: '#1976d2' }}>
                                    Regular Referrer Rewards (what the person who shared the code gets)
                                </Typography>
                                <div className={classes.fieldGrid} style={{ marginBottom: 32 }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Field
                                            name="referrer_gets_sprive_plus"
                                            component={renderSwitch}
                                            label="Gets Sprive Plus"
                                            type="checkbox"
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Field
                                            name="referrer_gets_boost"
                                            component={renderSwitch}
                                            label="Gets Boost"
                                            type="checkbox"
                                        />
                                    </div>
                                    <Field
                                        name="referrer_bonus_amount"
                                        component={renderCurrencyInput}
                                        label="Cash Bonus"
                                        placeholder="5.00"
                                    />
                                </div>

                                {/* Ambassador Rewards */}
                                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 16, color: '#9c27b0' }}>
                                    Ambassador Rewards (after reaching threshold)
                                </Typography>
                                <div className={classes.fieldGrid} style={{ marginBottom: 32 }}>
                                    <Field
                                        name="ambassador_threshold"
                                        component={renderNumberInput}
                                        label="Threshold (referrals to become ambassador)"
                                        placeholder="10"
                                    />
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Field
                                            name="ambassador_gets_sprive_plus"
                                            component={renderSwitch}
                                            label="Gets Sprive Plus"
                                            type="checkbox"
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Field
                                            name="ambassador_gets_boost"
                                            component={renderSwitch}
                                            label="Gets Boost"
                                            type="checkbox"
                                        />
                                    </div>
                                    <Field
                                        name="ambassador_bonus_amount"
                                        component={renderCurrencyInput}
                                        label="Cash Bonus"
                                        placeholder="10.00"
                                    />
                                </div>

                                {/* Referred User Rewards */}
                                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 16, color: '#2e7d32' }}>
                                    Referred User Rewards (what the new user who used the code gets)
                                </Typography>
                                <div className={classes.fieldGrid}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Field
                                            name="referred_gets_sprive_plus"
                                            component={renderSwitch}
                                            label="Gets Sprive Plus"
                                            type="checkbox"
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Field
                                            name="referred_gets_boost"
                                            component={renderSwitch}
                                            label="Gets Boost"
                                            type="checkbox"
                                        />
                                    </div>
                                    <Field
                                        name="referred_bonus_amount"
                                        component={renderCurrencyInput}
                                        label="Cash Bonus"
                                        placeholder="0.00"
                                    />
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* Section 3: Boost Settings */}
                        <Accordion
                            className={classes.accordion}
                            expanded={expandedSections.includes("boost")}
                            onChange={handleAccordionChange("boost")}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <FlashOnIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Boost Settings</Typography>
                                <Typography className={classes.sectionDescription}>
                                    Configure boost duration and limits
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <Field
                                        name="boost_duration_days"
                                        component={renderNumberInput}
                                        label="Boost Duration (Days)"
                                        placeholder="7"
                                    />
                                    <Field
                                        name="boost_weeks_per_referral"
                                        component={renderNumberInput}
                                        label="Boost Weeks Per Referral"
                                        placeholder="1"
                                    />
                                    <Field
                                        name="max_boost_weeks"
                                        component={renderNumberInput}
                                        label="Max Boost Weeks"
                                        placeholder="10"
                                    />
                                    <Field
                                        name="boost_haircut_percentage"
                                        component={renderNumberInput}
                                        label="Boost Haircut % (0 = user gets full discount)"
                                        placeholder="0"
                                    />
                                </div>
                                <Typography variant="caption" style={{ color: '#666', marginTop: 16, display: 'block' }}>
                                    <span role="img" aria-label="info">💡</span> Boost Haircut: When boost is active, this is the Sprive cut % instead of the regular haircut.
                                    Set to 0 for users to get full cashback, or higher for Sprive to retain some margin.
                                    Brand-specific overrides can be set in the Gift Card Brand Mapping table.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        {/* Section 4: Share Screen Config */}
                        <Accordion
                            className={classes.accordion}
                            expanded={expandedSections.includes("share")}
                            onChange={handleAccordionChange("share")}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <ShareIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Share Screen Config</Typography>
                                <Typography className={classes.sectionDescription}>
                                    Customize the referral share screen content
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <FormSpy subscription={{ values: true }}>
                                    {({ values }) => (
                                        <div className={classes.previewContainer}>
                                            <div className={classes.previewFields}>
                                                <div className={classes.shareFieldGrid}>
                                                    <Field
                                                        name="share_screen_title"
                                                        component={renderTextArea}
                                                        label="Share Screen Title"
                                                        placeholder="Invite friends & earn rewards"
                                                    />
                                                    <Field
                                                        name="share_screen_subtitle"
                                                        component={renderTextArea}
                                                        label="Share Screen Subtitle"
                                                        placeholder="Share your code with friends"
                                                    />
                                                    <Field
                                                        name="share_screen_cta_text"
                                                        component={renderInput}
                                                        label="CTA Button Text"
                                                        placeholder="Share Now"
                                                    />
                                                    <div style={{ gridColumn: 'span 2' }}>
                                                        <Field
                                                            name="share_message_template"
                                                            component={renderLargeTextArea}
                                                            label="Share Message Template (use {referral_code}, {bonus}, {shareLink})"
                                                            placeholder="Hey, I've been using Sprive to save £££s on my mortgage just by doing my everyday shopping. Sign up with my code {referral_code} and you'll get Sprive Plus for free. Here's the link: {shareLink}"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Live Phone Preview */}
                                            <div className={classes.phonePreview}>
                                                <div className={classes.phoneHeader} />
                                                <div className={classes.phoneContent}>
                                                    <div className={classes.phoneIcon}>
                                                        <PersonAddIcon style={{ fontSize: 28, color: "#1a1a2e" }} />
                                                        <div className={classes.phoneIconBadge}>+</div>
                                                    </div>
                                                    <div className={classes.phoneTitle}>
                                                        {values.share_screen_title || "Share Screen Title"}
                                                    </div>
                                                    <div className={classes.phoneSubtitle}>
                                                        {values.share_screen_subtitle || "Share Screen Subtitle"}
                                                    </div>
                                                    <div className={classes.phoneCodeSection}>
                                                        <div>
                                                            <div className={classes.phoneCodeLabel}>Your referral code</div>
                                                            <div className={classes.phoneCode}>BRV15UES</div>
                                                        </div>
                                                        <div className={classes.phoneCopyButton}>
                                                            Copy code
                                                        </div>
                                                    </div>
                                                    <button className={classes.phoneCTA} type="button">
                                                        {values.share_screen_cta_text || "Share with friends"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </FormSpy>
                            </AccordionDetails>
                        </Accordion>

                        {/* Section 5: Featured Brands */}
                        <Accordion
                            className={classes.accordion}
                            expanded={expandedSections.includes("featuredBrands")}
                            onChange={handleAccordionChange("featuredBrands")}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <ViewCarouselIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Featured Brands</Typography>
                                <Typography className={classes.sectionDescription}>
                                    Select 3 brands to feature in boost screen (enter gift_card IDs)
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <Field
                                        name="featured_brand_id_1"
                                        component={renderNumberInput}
                                        label="Featured Brand ID 1"
                                        placeholder="e.g. 1 for ASDA"
                                    />
                                    <Field
                                        name="featured_brand_id_2"
                                        component={renderNumberInput}
                                        label="Featured Brand ID 2"
                                        placeholder="e.g. 2 for Sainsbury's"
                                    />
                                    <Field
                                        name="featured_brand_id_3"
                                        component={renderNumberInput}
                                        label="Featured Brand ID 3"
                                        placeholder="e.g. 713 for Tesco"
                                    />
                                </div>
                                {/* Show loaded brands */}
                                {featuredBrands.length > 0 && (
                                    <div style={{ marginTop: 16, display: 'flex', gap: 16 }}>
                                        {featuredBrands.map((brand) => (
                                            <div key={brand.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', backgroundColor: '#f5f5f5', borderRadius: 8 }}>
                                                {brand.brandLogo && <img src={brand.brandLogo} alt={brand.brandName} style={{ width: 40, height: 30, objectFit: 'contain' }} />}
                                                <div>
                                                    <div style={{ fontSize: 12, fontWeight: 600 }}>{brand.brandName}</div>
                                                    <div style={{ fontSize: 11, color: '#666' }}>{brand.discount}% cashback</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </AccordionDetails>
                        </Accordion>

                        {/* Section 6: Boost Screen Configuration (5 variations) */}
                        <Accordion
                            className={classes.accordion}
                            expanded={expandedSections.includes("boostScreen")}
                            onChange={handleAccordionChange("boostScreen")}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <WhatshotIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Boost Screen Configuration</Typography>
                                <Typography className={classes.sectionDescription}>
                                    Configure boost popup for 5 user variations
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.boostPreviewContainer}>
                                    {/* Form Section */}
                                    <div className={classes.boostFormSection}>
                                        {/* Variation Selector */}
                                        <FormControl variant="outlined" className={classes.boostVariationSelect}>
                                            <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>
                                                Select User Variation
                                            </Typography>
                                            <Select
                                                value={selectedVariation}
                                                onChange={(e) => setSelectedVariation(e.target.value as string)}
                                            >
                                                {BOOST_VARIATIONS.map((v) => (
                                                    <MenuItem key={v.key} value={v.key}>{v.label}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        {/* Dynamic Form Fields */}
                                        <div className={classes.fieldGrid}>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Title</Typography>
                                                <TextField
                                                    value={currentVariation.title || ''}
                                                    onChange={(e) => updateBoostVariationField('title', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="Rewards boosted!"
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Subtitle</Typography>
                                                <TextField
                                                    value={currentVariation.subtitle || ''}
                                                    onChange={(e) => updateBoostVariationField('subtitle', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    multiline
                                                    rows={2}
                                                    placeholder="Each boost increases your shopping reward..."
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>CTA Title</Typography>
                                                <TextField
                                                    value={currentVariation.cta_title || ''}
                                                    onChange={(e) => updateBoostVariationField('cta_title', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="Extend your boost + win up to £1k"
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>CTA Subtitle</Typography>
                                                <TextField
                                                    value={currentVariation.cta_subtitle || ''}
                                                    onChange={(e) => updateBoostVariationField('cta_subtitle', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    multiline
                                                    rows={2}
                                                    placeholder="Get a prize draw entry..."
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Primary Button Text</Typography>
                                                <TextField
                                                    value={currentVariation.primary_button_text || ''}
                                                    onChange={(e) => updateBoostVariationField('primary_button_text', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="Refer a friend"
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Primary Button Action</Typography>
                                                <TextField
                                                    value={currentVariation.primary_button_action || ''}
                                                    onChange={(e) => updateBoostVariationField('primary_button_action', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="navigate_referral"
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Secondary Button Text</Typography>
                                                <TextField
                                                    value={currentVariation.secondary_button_text || ''}
                                                    onChange={(e) => updateBoostVariationField('secondary_button_text', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="Shop now"
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Secondary Button Action</Typography>
                                                <TextField
                                                    value={currentVariation.secondary_button_action || ''}
                                                    onChange={(e) => updateBoostVariationField('secondary_button_action', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="navigate_shopping"
                                                />
                                            </div>
                                            <div style={{ gridColumn: 'span 3' }}>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Highlight Text (small text below CTA subtitle)</Typography>
                                                <TextField
                                                    value={currentVariation.highlight_text || ''}
                                                    onChange={(e) => updateBoostVariationField('highlight_text', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="The minimum you'll earn is 1 boost and £5."
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Live Preview */}
                                    <div className={classes.boostPreview}>
                                        <div className={classes.boostPreviewHeader}>
                                            <img src="/fire.gif" alt="Fire" className={classes.boostFireIcon} />
                                            <div className={classes.boostBadge}>2</div>
                                            <div className={classes.boostPreviewTitle}>
                                                {currentVariation.title || 'Rewards boosted!'}
                                            </div>
                                            <div className={classes.boostPreviewSubtitle}>
                                                {currentVariation.subtitle || 'Each boost increases your shopping reward at ALL brands for 7 days.'}
                                            </div>
                                        </div>
                                        <div className={classes.boostBrandCards}>
                                            {featuredBrands.length > 0 ? (
                                                featuredBrands.map((brand, index) => (
                                                    <div key={brand.id || index} className={classes.boostBrandCard}>
                                                        <div className={classes.boostBrandCardInner}>
                                                            <div className={classes.boostBrandLogoSection}>
                                                                {brand.brandLogo ? (
                                                                    <img
                                                                        src={brand.brandLogo}
                                                                        alt={brand.brandName}
                                                                        className={classes.boostBrandLogo}
                                                                    />
                                                                ) : (
                                                                    <div style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>{brand.brandName}</div>
                                                                )}
                                                            </div>
                                                            <div className={classes.boostDiscountBar}>
                                                                <span className={classes.boostDiscountText}>{brand.discount}%</span>
                                                            </div>
                                                            <div className={classes.boostFireContainer}>
                                                                <img src="/fireflash.gif" alt="" className={classes.boostBadgeFireIcon} />
                                                                <img src="/flash.svg" alt="" className={classes.boostFlashIcon} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <>
                                                    {[1, 2, 3].map((num) => (
                                                        <div key={num} className={classes.boostBrandCard}>
                                                            <div className={classes.boostBrandCardInner}>
                                                                <div className={classes.boostBrandLogoSection}>
                                                                    <div style={{ fontSize: 12, color: '#999', fontWeight: 600 }}>Brand {num}</div>
                                                                </div>
                                                                <div className={classes.boostDiscountBar} style={{ background: 'linear-gradient(90deg, #ccc 24.76%, #e0e0e0 43.69%)' }}>
                                                                    <span className={classes.boostDiscountText} style={{ color: '#999' }}>--%</span>
                                                                </div>
                                                                <div className={classes.boostFireContainer} style={{ opacity: 0.4 }}>
                                                                    <img src="/fireflash.gif" alt="" className={classes.boostBadgeFireIcon} />
                                                                    <img src="/flash.svg" alt="" className={classes.boostFlashIcon} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                        <div className={classes.boostCtaSection}>
                                            <img src="/chest.svg" alt="Chest" className={classes.boostCtaIcon} />
                                            <div className={classes.boostCtaTitle}>
                                                {currentVariation.cta_title || 'Extend your boost + win up to £1k'}
                                            </div>
                                            <div className={classes.boostCtaSubtitle}>
                                                {currentVariation.cta_subtitle || 'Get a prize draw entry and extend your boost by referring a friend.'}
                                            </div>
                                            {currentVariation.highlight_text && (
                                                <div style={{ fontSize: 11, color: '#888', marginBottom: 12, fontStyle: 'italic' }}>
                                                    {currentVariation.highlight_text}
                                                </div>
                                            )}
                                            <div className={classes.boostButtonsRow}>
                                                {currentVariation.primary_button_text && (
                                                    <div
                                                        className={currentVariation.secondary_button_text ? classes.boostButtonPrimary : classes.boostButtonSecondary}
                                                        style={!currentVariation.secondary_button_text ? { flex: 1 } : {}}
                                                    >
                                                        {currentVariation.primary_button_text}
                                                    </div>
                                                )}
                                                {currentVariation.secondary_button_text && (
                                                    <div className={classes.boostButtonSecondary} style={!currentVariation.primary_button_text ? { flex: 1 } : {}}>
                                                        {currentVariation.secondary_button_text}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* Section 8: Rewards Screen Configuration (2 variations) */}
                        <Accordion
                            className={classes.accordion}
                            expanded={expandedSections.includes("rewardsScreen")}
                            onChange={handleAccordionChange("rewardsScreen")}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <CardGiftcardIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Rewards Screen Configuration</Typography>
                                <Typography className={classes.sectionDescription}>
                                    Configure rewards screen for normal users and ambassadors
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.rewardsPreviewContainer}>
                                    {/* Form Section */}
                                    <div className={classes.rewardsFormSection}>
                                        {/* Variation Selector */}
                                        <FormControl variant="outlined" className={classes.boostVariationSelect}>
                                            <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>
                                                Select User Type
                                            </Typography>
                                            <Select
                                                value={selectedRewardsVariation}
                                                onChange={(e) => setSelectedRewardsVariation(e.target.value as string)}
                                            >
                                                <MenuItem value="normal_user">Normal User</MenuItem>
                                                <MenuItem value="ambassador">Ambassador</MenuItem>
                                            </Select>
                                        </FormControl>

                                        {/* Dynamic Form Fields */}
                                        <div className={classes.fieldGrid}>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Badge Text</Typography>
                                                <TextField
                                                    value={currentRewardsVariation.badge_text || ''}
                                                    onChange={(e) => updateRewardsVariationField('badge_text', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder={selectedRewardsVariation === 'ambassador' ? "Exclusive to Sprive Ambassadors" : "Exclusive to Sprive Plus"}
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Title</Typography>
                                                <TextField
                                                    value={currentRewardsVariation.title || ''}
                                                    onChange={(e) => updateRewardsVariationField('title', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder={selectedRewardsVariation === 'ambassador' ? "Earn £10 for each new referral" : "Earn a boost AND £5 for each friend you refer"}
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>CTA Button Text</Typography>
                                                <TextField
                                                    value={currentRewardsVariation.cta_text || ''}
                                                    onChange={(e) => updateRewardsVariationField('cta_text', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder={selectedRewardsVariation === 'ambassador' ? "Refer using {firstName}" : "Refer a friend"}
                                                />
                                            </div>
                                            <div>
                                                <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Footer Text</Typography>
                                                <TextField
                                                    value={currentRewardsVariation.footer_text || ''}
                                                    onChange={(e) => updateRewardsVariationField('footer_text', e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder={selectedRewardsVariation === 'ambassador' ? "Contact Sprive if you'd like to discuss anything." : "The £5 overpays your mortgage. Read terms."}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Live Preview */}
                                    <div className={classes.rewardsPreview}>
                                        {/* Stats Row */}
                                        <div className={classes.rewardsStatsRow}>
                                            <div className={classes.rewardsStatBox}>
                                                <span className={classes.rewardsStatLabel}>New referrals</span>
                                                <div className={classes.rewardsStatValue}>
                                                    <PersonOutlineIcon style={{ fontSize: 18, color: '#1a1a2e' }} />
                                                    <span style={{ fontWeight: 600, color: '#1a1a2e' }}>0</span>
                                                </div>
                                                <span className={classes.rewardsPastReferrals}>8 past referrals</span>
                                            </div>
                                            <div className={classes.rewardsStatBox} style={{ alignItems: 'flex-end' }}>
                                                <span className={classes.rewardsStatLabel}>Earned to-date</span>
                                                <div className={classes.rewardsEarnedBadge}>
                                                    <span style={{ fontWeight: 600, color: '#1a1a2e' }}>£120.00</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Main Content */}
                                        <div className={classes.rewardsMainContent}>
                                            <div style={{ position: 'relative', marginBottom: 12 }}>
                                                <div style={{
                                                    width: 50,
                                                    height: 50,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#1a1a2e',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>
                                                    <img src="/fireflash.gif" alt="" style={{ width: 34, height: 34 }} />
                                                </div>
                                                <div style={{
                                                    position: 'absolute',
                                                    bottom: -4,
                                                    right: -8,
                                                    width: 24,
                                                    height: 24,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#1a1a2e',
                                                    border: '2px solid #FFAE00',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: '#FFAE00',
                                                    fontSize: 16,
                                                    fontWeight: 700
                                                }}>+</div>
                                            </div>
                                            <span className={classes.rewardsBadgeText}>
                                                {currentRewardsVariation.badge_text || (selectedRewardsVariation === 'ambassador' ? 'Exclusive to Sprive Ambassadors' : 'Exclusive to Sprive Plus')}
                                            </span>
                                            <div className={classes.rewardsTitle}>
                                                {currentRewardsVariation.title || (selectedRewardsVariation === 'ambassador' ? 'Earn £10 for each new referral' : 'Earn a boost AND £5 for each friend you refer')}
                                                <InfoOutlinedIcon style={{ fontSize: 18, marginLeft: 4, verticalAlign: 'middle', opacity: 0.7 }} />
                                            </div>
                                        </div>

                                        {/* Coins Background */}
                                        <div className={classes.rewardsCoinsSection}>
                                            {expandedSections.includes("rewardsScreen") && (
                                                <div className={classes.rewardsCoinStack} key={`coins-${Date.now()}`}>
                                                    {[0, 1, 2, 3, 4].map((index) => (
                                                        <img
                                                            key={index}
                                                            src="/coin.png"
                                                            alt=""
                                                            className={classes.rewardsCoin}
                                                            style={{
                                                                bottom: index * 18,
                                                                zIndex: index + 1,
                                                                left: `calc(50% + ${index % 2 === 0 ? -4 : 4}px)`,
                                                                animationDelay: `${index * 0.15}s`
                                                            }}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        {/* Bottom Section */}
                                        <div className={classes.rewardsBottomSection}>
                                            <div className={classes.rewardsCtaButton}>
                                                {currentRewardsVariation.cta_text || (selectedRewardsVariation === 'ambassador' ? 'Refer using {firstName}' : 'Refer a friend')}
                                            </div>
                                            <div className={classes.rewardsFooterText}>
                                                {currentRewardsVariation.footer_text || (selectedRewardsVariation === 'ambassador' ? 'Contact Sprive if you\'d like to discuss anything.' : 'The £5 overpays your mortgage. Read terms.')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* Section 10: Status */}
                        <Accordion
                            className={classes.accordion}
                            expanded={expandedSections.includes("status")}
                            onChange={handleAccordionChange("status")}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <ToggleOnIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Status</Typography>
                                <Typography className={classes.sectionDescription}>
                                    Enable or disable this configuration
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.statusSwitch}>
                                    <Field
                                        name="is_active"
                                        component={renderSwitch}
                                        label="Configuration Active"
                                        type="checkbox"
                                    />
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        <Notification />
                    </div>
                </form>
            )}
        />
    );
};

export default ReferralConfig;
